import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";


export default function DynamicTab({ tabs, activeTabPathName, onTabChange }) {
  // Find the index of the tab with the matching label, default to 0 if not found
  const activeTabIndex = tabs.findIndex(tab => tab.pathname === activeTabPathName) !== -1 ? tabs.findIndex(tab => tab.pathname === activeTabPathName) : 0;

  const handleChange = (event, newValue) => {
    const newTabPathName = tabs[newValue].pathname; // Get label from new index
    if (onTabChange) {
      onTabChange(newTabPathName); // Pass label instead of index
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs value={activeTabIndex} onChange={handleChange} aria-label="dynamic tabs">
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
      <Box sx={{ p: 2 }}>
        {tabs.map((tab, index) => (
          activeTabIndex === index && (
            <Box key={index}>
              {typeof tab.component === "string" ? (<Typography>{tab.component}</Typography>) : (<tab.component />)}
            </Box>
          )
        ))}
      </Box>
    </Box>
  );
}